<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <h1 style="color: var(--job-title-color)">
          {{job.title}}
        </h1>
        <div class="my-2">
          <p v-html="job.long_description">
          </p>
          <!-- <p>
            Our app is a React app built on the Overwolf modding/overlay
            platform. It is somewhat similar to the sample act here:
          </p>
          <a href=""
            >https://overwolf.github.io/docs/start/sample-app-overview
          </a>
          <p>
            The first task involves communicating with a DLL in our React app -
            we have implemented a ready message that's sent from our DLL. We now
            need the front end to listen to that ready message, and wait until
            it is received before we started sending it more messages. Then we
            need to update with user-specific settings once the engine is ready.
            Currently we're having synchronization issues. That is priority
            number 1.
          </p> -->
          <p>
            {{job.short_description}}
          </p>
        </div>
        <div class="row" style="align-items: center">
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="user" />
              <h6 class="ml-3">
                {{job.company.company_name}} <br />
                <small>Company Name</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="briefcase" />
              <h6 class="ml-3">
                ${{job.bid_range + '/'+ job.range}}<br />
                <small> Bid Range</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="type" />
              <h6 class="ml-3">
                {{job.job_type}}<br />
                <small> Job Type</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="calendar" />
              <h6 class="ml-3">
                {{job.start_date}} <br />
                <small>Start Date</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="calendar" />
              <h6 class="ml-3">
                {{job.end_date}}<br />
                <small> End Date</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="clock" />
              <h6 class="ml-3">
                {{job.region}}<br />
                <small> Region</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="clock" />
              <h6 class="ml-3">
                {{job.framework}}<br />
                <small>Framework</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="clock" />
              <h6 class="ml-3">
                {{job.notice}}<br />
                <small> Notice</small>
              </h6>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 my-3">
            <div class="d-flex">
              <app-icon name="clock" />
              <h6 class="ml-3">
                {{job.threshold}}<br />
                <small>Threshold</small>
              </h6>
            </div>
          </div>
        </div>
        <!-- <div class="row my-3">
          <div class="col-sm-12">
            <h5>Skills and Expertise</h5>
          </div>
          <div class="col-sm-12 mt-3">
            <ul class="bollets_skills">
              <li><span> React</span></li>
              <li><span> React</span></li>
              <li><span> React</span></li>
              <li><span> React</span></li>
            </ul>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-sm-12">
            <h5>Activity on this job</h5>
          </div>
          <div class="col-sm-12 mt-3">
            <div class="row">
              <div class="col-lg-4 col-12 my-3">
                <h6>
                  20 to 50 <br />
                  <small>Proposals</small>
                </h6>
              </div>
              <div class="col-lg-4 col-12 my-3">
                <h6>
                  26 minutes ago<br />
                  <small>Last viewed by clien</small>
                </h6>
              </div>
              <div class="col-lg-4 col-12 my-3">
                <h6>
                  0<br />
                  <small>Interviewing</small>
                </h6>
              </div>
              <div class="col-lg-4 col-12 my-3">
                <h6>
                  0<br />
                  <small>Invites sent</small>
                </h6>
              </div>
              <div class="col-lg-4 col-12 my-3">
                <h6>
                  0<br />
                  <small>Invites sent</small>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="d-flex" style="align-items: baseline">
              <div><h5>About the client</h5></div>
              <div class="ml-3"><small> Member since Jul 21, 2020 </small></div>
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <div class="row">
              <div class="col-lg-4 col-sm-12 my-3">
                <h6>
                  United States <br />
                  <small>Los Gatos 12:51 pm</small>
                </h6>
              </div>
              <div class="col-lg-4 col-sm-12 my-3">
                <h6>
                  36 jobs posted <br />
                  <small>73% hire rate, 2 open jobs</small>
                </h6>
              </div>
              <div class="col-lg-4 col-sm-12 my-3">
                <h6>
                  $3k+ total spent <br />
                  <small>31 hires, 6 active</small>
                </h6>
              </div>
              <div class="col-lg-4 col-sm-12 my-3">
                <h6>
                  26.46 /hr avg hourly rate paid <br />
                  <small>84 hours </small>
                </h6>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { COMPANY_JOB_SHOW } from "../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";
// import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "Job-Detail",
  // props: ["componentProps"],
  //   components: { CopyButton },
  data() {
    return {
      preloader:true,
      job: {},
    };
  },
  methods: {
    getJob() {
      
      
      let id = this.$attrs['props'];
      axiosGet(COMPANY_JOB_SHOW + "/" + id.id)
        .then((res) => {
          this.job = res.data;
          
          
        })
        .catch((error) => {
          
        }).finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    this.getJob();
  },
};
</script>


<style scoped>
.bollets_skills {
  display: flex;
  padding: 0px;
}
.bollets_skills li {
  padding: 0px 10px 0px 10px;
}
.bollets_skills li span {
  background: #c7d2ff;
  border-radius: 35px;
  height: auto !important;
  padding: 3px 10px !important;
  color: var(--base-color);
}
</style>
